import { useMutation } from "@tanstack/react-query";
import { BookingService } from "@/services/BookingService";
import type { Booking } from "@/types/Booking";

type UpdateBookingDateTimeParams = {
  bookingId: string;
  newDate: string;
  newStartTime: string;
  newEndTime: string;
  waive?: boolean;
};

/**
 * Hook to update a booking's date and time
 * Uses React Query's useMutation for proper loading/error states and automatic cache invalidation
 */
export function useUpdateBookingDateTime() {
  const bookingService = new BookingService();

  return useMutation<Booking, Error, UpdateBookingDateTimeParams>({
    mutationFn: async (params: UpdateBookingDateTimeParams) => {
      return await bookingService.updateBookingDateTime(
        params.bookingId,
        params.newDate,
        params.newStartTime,
        params.newEndTime,
        params.waive,
      );
    },
  });
}
